export default [{
  path: '/assistencia-tecnica',
  name: 'assistencia-tecnica',
  component: () => import('@/views/app/AssistenciaTecnica/Index.vue'),
  meta: { pageTitle: 'Assistência Técnica', resource: 'AssistenciaTecnica', action: 'read', explicitModule: true, activeAdminDkpOnly: true },
}];